module Meevo.Plugins.AppointmentBook {
    class DeleteController {
        appointHeaderDelete: {
            services: any[],
            isApptToDeleteSelected: boolean,
        };
        shouldSelectAll: boolean = false;

        static $inject = [
            'appointmentBookActionsService',
            'appointmentBookModalService',
            'appointmentBookHelperService',
            'AppointmentEditorService',
            'appointmentServiceIdsToDelete',
        ];

        constructor(
            private actions,
            private modal,
            private helper,
            private appointmentEditorService,
            appointmentServiceIdsToDelete
        ) {
            this.appointHeaderDelete = this.actions.appointHeaderDelete;

            _(appointmentServiceIdsToDelete).each((id) => {
                const matchingService = _(this.appointHeaderDelete.services).find((appointmentService) => appointmentService.id == id);
                if (matchingService) {
                    matchingService.isApptToDeleteSelected = true;
                }
            });

            this.checkIfAllSelected();
        }

        cancelNoShowClick(client) {
            this.modal.hideModal({}).then(() => {
                this.appointmentEditorService.openCancelledOrNoShowAppointmentHistory(client);
            });
        }

        selectUnselectAllAppts() {
            _(this.appointHeaderDelete.services).map((service) => {
                service.isApptToDeleteSelected = this.shouldSelectAll;
            });
        }

        checkIfAllSelected() {
            const selectedDeletedServiceCount = this.appointHeaderDelete.services.filter((service) => service.isApptToDeleteSelected).length;
            return this.shouldSelectAll = selectedDeletedServiceCount == this.appointHeaderDelete.services.length;
        }

        saveDelete() {
            this.actions.deleteAppointmentFinal();
        }

        closeDelete() {
            this.helper.closeDelete();
            this.helper.checkReturnToState(this.actions, false);
        }
    }

    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.DeleteController", DeleteController);
}